export interface DataRoomDocument {
	id: number;
	guid: string;
	folderGuid: string;
	name: string;
	fileName: string;
	documentDate: Date;
	documentType: DocumentType;
	isVisibleToAll: boolean;
	dataRoomUsers: number[];
	folderPath: string;
}

export type DocumentType = keyof typeof DocumentTypeMap;
export const DocumentTypeMap = {
	Financial_Statement: 'Financial Statement',
	PersonalFinancial: 'Personal Financial Statement',
	FinancialProjections: 'Financial Projections',
	Budget: 'Budget',
	CapTable: 'Cap Table',
	AccountAnalysisStatement: 'Account Analysis Statement',
	BankStatement: 'Bank Statement',
	CompanyValuation: 'Company Valuation',
	EquipmentAppraisal: 'Equipment Appraisal',
	RealEstateAppraisal: 'Real Estate Appraisal',
	AR_Agings: 'AR Agings',
	AP_Agings: 'AP Agings',
	Loan_Document: 'Loan Document',
	DebtSchedule: 'Debt Schedule',
	CorpTax: 'Tax Document – Corporate',
	PrincipalTax: 'Tax Document – Principal',
	Collateral: 'Collateral',
	Valuation: 'Valuation',
	Diligence: 'Diligence',
	CompanyOverviewMaterials: 'Company Overview Materials',
	BoardReports: 'Board Reports',
	OrganizationalChart: 'Organizational Chart',
	IpDocs: 'IP Doc',
	ManagementBios: 'Management Bios',
	EmployeeDocument: 'Employee Document',
	OrganizationalDocument: 'Organizational Document',
	SbaForm: 'SBA Form',
	SbaSupportingDocument: 'SBA Supporting Document',
	Nda: 'NDA',
	FinancialUpload: 'Financial Upload',
	ExecutiveSummary: 'Executive Summary',
	BorrowingBase: 'Borrowing Base',
	Other: 'Other',
};
